import { Navigate } from "react-router";
import NotFoundPage from "../../../img/PageNotFound.png";
import CopyRight from "../../../Components/Login/CopyRight";

const PageNotFound = () => {
  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center min-vh-100">
        <img
          src={NotFoundPage}
          alt=""
          className=" mb-3"
          style={{ height: "40vh" }}
        />

        <div className="tnc">
          <h1 className="copyright text-center mb-3 bold">We are Sorry...</h1>

          <div className="text-center copyright mb-5">
            <div>The Requested URL was not found on thus server.</div>

            <div>That's all we know</div>
          </div>

          <button
            type="submit"
            className="mb-2 w-100 btn signinbutton"
            onClick={() => Navigate(-1)}
          >
            Go Back
          </button>

          <CopyRight />
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
